import type React from "react";
import { Box, Tooltip, TooltipPopup, TooltipTrigger } from "@salestrak/ui";

type TooltipSide = React.ComponentProps<typeof TooltipPopup>["side"];

/**
 * Entity action menus DISABLE rows the viewer cannot use rather than hide
 * them (the view-tab menu's house rule): a menu whose rows come and go by
 * role makes the same row a different row depending on who opened it. A
 * disabled row says why in a tooltip — this is that tooltip.
 */

export const NO_PERMISSION = "Do not have permission";

/**
 * For rows that are NOT library menu items — option-panel rows and the like.
 * A menu row (`MenuItem`, `MenuSubTrigger`, their context-menu twins) takes
 * the library's `disabledReason` prop instead: there the row element itself is
 * the tooltip trigger, so nothing wraps its glyph and label and the row stays
 * aligned with its neighbours. This wrapper is a flex row around `children`,
 * which is why it never goes INSIDE a menu row.
 */
export function DisabledReason({
  reason,
  side,
  children,
}: {
  reason: string;
  /** Where the reason opens. Omitted, the enclosing region's default
   *  (`TooltipSideProvider` — the Customize view drawer sets `left`), else
   *  `top`, which suits a menu row whose neighbours are other rows. */
  side?: TooltipSide;
  children: React.ReactNode;
}) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={<Box direction="row" align="center" gap="sm" fill="width" />}
      >
        {children}
      </TooltipTrigger>
      <TooltipPopup side={side}>{reason}</TooltipPopup>
    </Tooltip>
  );
}
